import { HomeOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { ROUTES } from "@/shared/config";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Result
      status="404"
      title="404"
      subTitle={t("common.notFound")}
      extra={
        <Link to={ROUTES.dashboard}>
          <Button type="primary" icon={<HomeOutlined aria-hidden />}>
            {t("common.toDashboard")}
          </Button>
        </Link>
      }
    />
  );
}
